export default __webpack_public_path__ + "static/media/logo.cae829e3.png";